module.exports = __webpack_public_path__ + "media/fr_fr_s3_Sinclaire.918cf536.oga";